<template>
	<!--小按钮-->
	<button type="button" @click="$emit('click')" class="btn" :class="classCpt" :style="styleCpt">
		<slot>submit</slot>
	</button>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性   可使用与原生一样的属性(为防止与原生属性一样)
		props:['classCpt','styleCpt']
	}
</script>

<style scoped>
	button{ 
		padding:.2rem .5rem; 
		border-radius:0 ; 
		font-size: .7rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/btn-Small.vue